import React from 'react';
import SuccessPage from "../visa-orders/new/successPage";
import {useParams} from "react-router-dom";
import FailedPage from "../visa-orders/new/failedPage";

const Payment = () => {
  const param = useParams()
  console.log(param)
  return (
    <div>
      {
        param?.status === "success" ?
          <SuccessPage activeStep={true}/>
          :
          <FailedPage/>
      }
    </div>
  );
};

export default Payment;
